import { useRef, useState } from 'react';
import { endpoints } from '../../api';
import { uuid } from '../../api/client';
import { UploadTransportError } from '../../api/uploads';

/** Загрузка для JSON-ключа контракта экрана (`screen_fields[].upload`, docs/59 §1): общий хук формы грузит только
    поля шаблона, поэтому экран кладёт файл сам тем же POST /app/uploads → PUT → GET и пишет UUID в свой ключ.
    Неподтверждённая загрузка не теряется: её id можно проверить ещё раз, нового файла не создаётся. */
export function useScreenUpload() {
  const [busy, setBusy] = useState(false);
  const [pending, setPending] = useState<string | null>(null);
  const [error, setError] = useState('');
  const flight = useRef(false);
  async function run(task: () => Promise<{ id: string; status: string }>) {
    if (flight.current) return null;
    flight.current = true;
    setBusy(true);
    setError('');
    try {
      const slot = await task();
      if (slot.status !== 'ready') throw new Error('upload_not_ready');
      setPending(null);
      return slot.id;
    } catch (failure) {
      if (failure instanceof UploadTransportError) setPending(failure.uploadId);
      setError('Загрузка не подтверждена. Проверьте её ещё раз.');
      return null;
    } finally {
      flight.current = false;
      setBusy(false);
    }
  }
  return {
    busy,
    error,
    pending,
    upload: (file: File, kind: 'photo' | 'audio', purpose = 'order_input') =>
      run(() => endpoints.uploadFile(file, { purpose: purpose as 'order_input', kind, origin: 'file' }, uuid())),
    check: () => (pending ? run(() => endpoints.waitForUpload(pending)) : Promise.resolve(null)),
  };
}
